import { useMemo } from 'react';
import { Codes, MarketplaceWorkerNotification } from '../smartsend/SmartSendSocketsModels';
import { GetSocketMessage } from './GetSocketMessage';
import { P2GChip } from '@parcel2go/core-ui';

interface props {
  notification?: MarketplaceWorkerNotification;
  override?: string;
}

const ImportStatusChip: React.FC<props> = (props) => {
  const color: 'primary' | 'secondary' | 'default' | 'success' | 'error' | 'info' | 'danger' | 'warning' =
    useMemo(() => {
      switch (props?.notification?.Code) {
        case Codes.ImportFinished:
        case Codes.SyncShippedFinished:
          return 'success';
        case Codes.AuthorisationFailed:
        case Codes.CredentialsExpired:
        case Codes.CustomError:
        case Codes.SetupRequired:
        case Codes.ScopeMissing:
          return 'error';
        case Codes.ImportThrottled:
          return 'warning';
        default:
          return 'info';
      }
    }, [props?.notification?.Code]);

  const status: string = useMemo(
    () => `${props.override || GetSocketMessage(props?.notification) || props?.notification?.Status}`.toUpperCase(),
    [props?.notification, props.override]
  );

  return <P2GChip label={status} color={color} size="small" />;
};
export default ImportStatusChip;
